export const SITE_ORIGIN = "https://www.nilbeautyofficial.com";

export const encodeRouteSegment = (value: string | null | undefined) =>
  encodeURIComponent(String(value ?? "").trim());

export const productPath = (id: string | null | undefined) =>
  `/product/${encodeRouteSegment(id)}`;

export const productUrl = (id: string | null | undefined) =>
  `${SITE_ORIGIN}${productPath(id)}`;

export const productVariantUrl = (
  id: string | null | undefined,
  size: string | null | undefined,
) => {
  const base = productUrl(id);
  const cleanSize = String(size ?? "").trim();
  return cleanSize ? `${base}?size=${encodeURIComponent(cleanSize.toLowerCase())}` : base;
};

export const blogPostPath = (slug: string | null | undefined) =>
  `/blog/${encodeRouteSegment(slug)}`;

export const blogPostUrl = (slug: string | null | undefined) =>
  `${SITE_ORIGIN}${blogPostPath(slug)}`;

export const normalizeShareUrl = (url: string) => {
  try {
    return new URL(url, SITE_ORIGIN).toString();
  } catch {
    return url;
  }
};